<div
    class="group/item relative bg-white dark:bg-dark-contrast! border-0 rounded-md shadow-card dark:shadow-none overflow-hidden break-long-words bg-clip-border h-full"
    [ngClass]="{
        'shadow-card dark:shadow-none': hasShadow,
        'hover:shadow-lg-active active:shadow-lg-active focus:shadow-lg-active': hasLink && hasShadow
    }">
    <ng-content />
</div>
